/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import * as React from "react";
import * as Sentry from "@sentry/react";
import { useParams } from "react-router-dom";
import Button from "../../../../components/Layout/Button/index";
import Modal from "../../../../components/Modal/Modal";
import Typography from "../../../../components/Typography/Typography";
import InputField from "../../../../components/Layout/fieldInput/InputField";
import { SERVICES } from "../../../../components/Layout/Services";
import { put } from "../../../../components/Layout/ApiHandler/apihandler";
import { ToastAlertContext } from "../../../../Config/Providers/ToastAlert";
import { AlertStatus } from "../../../../contants";

export default function MemberUpdateModal({
  open,
  onClose,
  memberName,
  getUserProfile,
}) {
  const [memberUpdatedName, setUpdateMemberName] = React.useState(memberName);
  const { memberId } = useParams();
  const toast = React.useContext(ToastAlertContext);
  const onSubmit = async () => {
    const url = `${SERVICES.GET_MEMBER}/`;
    const data = {
      memberId,
      fullName: memberUpdatedName,
    };
    try {
      const response = await put(url, data);
      if (response.ok) {
        const res = await response.json();
        toast.show("Member Updated Successfully", AlertStatus.SUCCESS);
        await getUserProfile();
      } else {
        const errorData = await response.json();
        toast.show(errorData.message, AlertStatus.ERROR);
      }
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
    onClose();
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      onSubmit();
    }
  };
  React.useEffect(() => {
    setUpdateMemberName(memberName);
  }, [memberName]);

  return (
    <Box tabIndex="0" onKeyPress={handleKeyPress}>
      <Modal open={open} onClose={onClose}>
        <Typography
          style={{
            fontSize: "20px ",
            fontWeight: "500",
            paddingBottom: "20px",
          }}
        >
          Update Member Name
        </Typography>
        <InputField
          label="Member Name"
          value={memberUpdatedName}
          onChange={(event) => {
            const { value } = event.target;
            setUpdateMemberName(value);
          }}
          style={{ width: "350px" }}
          required
        />
        <Box
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "20px",
          }}
        >
          <Button
            onClick={onSubmit}
            width="40%"
            style={{
              marginRight: "10px",
            }}
          >
            Yes
          </Button>
          <Button
            onClick={onClose}
            cancel
            width="40%"
            style={{
              marginRight: "10px",
            }}
          >
            No
          </Button>
        </Box>
      </Modal>
    </Box>
  );
}
